import { APICore } from './apiCore'

const api = new APICore()

function getPersons (params) {
  const baseUrl = '/persons'
  return api.get(baseUrl, params)
}

function getPerson (id) {
  const baseUrl = `/persons/${id}`
  return api.get(baseUrl, {})
}

function addPerson (params) {
  const baseUrl = '/persons'
  return api.create(baseUrl, params)
}

function updatePerson (params) {
  const baseUrl = '/persons'
  return api.update(baseUrl, params)
}

function deletePerson (params) {
  const baseUrl = '/persons'
  return api.delete(baseUrl, params)
}

export { getPersons, getPerson, addPerson, updatePerson, deletePerson }
